window.addEventListener('load', () => {


  let thumbTitle = [`コードマン`, `コンコード`, `ザ・ゼノン`, `ビホルダーグループ(BG)`, `アウロスギア`];

  let wordsItem = new Swiper('.sentence__container', {
    containerModifierClass: `sentence__container`,
    wrapperClass: `sentence__wrapper`,
    slideClass: `sentence__item`,
    slideActiveClass: `sentence__item--active`,
    noSwiping: true,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    spaceBetween: 40,
    navigation: {
      nextEl: '.pg-world__navigation--next',
      prevEl: '.pg-world__navigation--prev',
    },
    pagination: {
      el: '.thumb__wrapper',
      clickable: true,
      bulletActiveClass: `thumb__item--active`,
      renderBullet: function (index, className) {
        return '<div class="thumb__item ' + className +'"><a href="javascript:void(0)">' + thumbTitle[index] + '</a></div>';
      },
    },
    on: {
      resize: () => {
        wordsItem.update();
      }
    }
  });



  let _modalImage = document.querySelectorAll(`.js-modalimage`);
  let modalImageLen = _modalImage.length;
  let _modalInner = document.querySelector(`.p-modal__media`);

  for (let i = 0; i < modalImageLen; i++) {

    let modalObj = new Modal();
    modalObj.bgClose();

    _modalImage[i].addEventListener(`click`, (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (_modalInner.classList.contains(`is-show`)) {
        _modalInner.textContent = null;
        _modalInner.classList.remove(`is-show`);
      }

      modalObj.open();

      let src = `../images/world/image_0` + _modalImage[i].getAttribute(`data-img`) + `.jpg`;
      let img = document.createElement(`img`);
      img.src = src;

      _modalInner.appendChild(img);
      _modalInner.classList.add(`is-show`);


      return false;
    }, {
      passive: false
    });

  }



});
